import React, {useContext} from "react";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import {getResponsiveStyles} from "../../utils/lib";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";

const LabelComponent = ({component}) => {
    const {styles: sourceStyles, properties: {label} = {}} = component;
    const {currentCustomResolution} = useContext(ScreenDesignerContextNew);
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(label, userLanguage);
    const styles = getResponsiveStyles(sourceStyles, currentCustomResolution);
    return (
        <div
            style={{
                width: '100%',
                textAlign: styles.textAlign
            }}
        >
            <span
                style={{
                    fontSize: styles.fontSize,
                    fontWeight: styles.fontWeight,
                    fontStyle: styles.fontStyle,
                    textDecoration: styles.textDecoration,
                    color: styles.color
                }}
            >
            {multiLanguageLabel}
            </span>
        </div>
    )
};

export default LabelComponent;